<template>
  <div class="container">
    <v-card-title>{{ title }}</v-card-title>
    <v-card>
      <Participants />
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import Participants from "../../components/races/Participants.vue";
import axios from "axios";

export default {
  mixins: [apiCalls], //for api redundant operations
  components: {
    Participants,
  },
  data() {
    return {
      title: "",
    };
  },
  mounted() {
    axios
      .get(
        `${this.root}/laravel/public/api/v1/promoter/race/getRaceEvent/${this.$route.params.id}`
      )
      .then((response) => {
        const {
          data: { message },
        } = response;
        const { eventName, raceName } =
          typeof message[0] != "undefined"
            ? message[0]
            : {
                eventName: "",
                raceName: "",
              };
        this.title = `${eventName} - ${raceName}`;
      }).catch(
          function(error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );
  },
};
</script>
